import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import nopdf from "../../assets/images/imagepreview.jpg";
import CryptoJS from "crypto-js";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

type Props = {};

const EmployeeAdd = (props: Props) => {
  const { i18n, t } = useTranslation();
 
  const [EmpDesignation, setEmpDesignation] = useState<any>([{ value: "-1", label: t("text.SelectDesignation") }]);
  const [Department, setDepartment] = useState<any>([{ value: "-1", label: t("text.SelectDepartment")}]);
  const [StateOption, setStateOption] = useState<any>([{ value: "-1", label: t("text.SelectState") }]);
  const [Country, setCountry] = useState<any>([{ value: "-1", label: t("text.SelectCountry") }]);
  const [City, setCity] = useState<any>([{ value: "-1", label:t("text.SelectDistrict") }]);
  const [Gender, setGender] = useState<any>([{ value: "-1", label: t("text.SelectGender") }]);
  const [Role, setRole] = useState<any>([{ value: "-1", label: t("text.SelectRole") }]);

  // State for toggling visibility of PAN and Aadhaar
  const [showPan, setShowPan] = useState(false);
  const [showAadhaar, setShowAadhaar] = useState(false);

  useEffect(() => {
    getEmpDesignation();
    getDepartment();
    getState();
    getCountry();
    getCity();
    getGender();
    getRole();
  }, []);

  const getEmpDesignation = () => {
    const collectData = { "designation_id": -1, "uid": "", "inst_ID": -1, "cat_id": -1 };
    axios.post(HOST_URL.HOST_URL2 + `Designation/GetDesignationmaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({ label: item.designation_name, value: item.designation_id }));
        setEmpDesignation(arr);
      });
  };

  const getDepartment = () => {
    const collectData = { "dept_id": -1, "dept_name": "", "user_id": "", "inst_ID": -1 };
    axios.post(HOST_URL.HOST_URL2 + `Department/GetDepartmentmaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({ label: item.dept_name, value: item.dept_id }));
        setDepartment(arr);
      });
  };

  const getState = () => {
    const collectData = { "state_id": -1, "country_id": -1 };
    axios.post(HOST_URL.HOST_URL2 + `State/GetStateMaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({ label: item.state_name, value: item.state_id }));
        setStateOption(arr);
      });
  };

  const getCountry = () => {
    const collectData = { "country_id": -1, "user_id": "", "inst_ID": -1 };
    axios.post(HOST_URL.HOST_URL2 + `Country/GetCountryMaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({ label: item.country_name, value: item.country_id }));
        setCountry(arr);
      });
  };

  const getCity = () => {
    const collectData = { "city_id": -1, "state_id": -1 };
    axios.post(HOST_URL.HOST_URL2 + `District/GetDistrictMaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({ label: item.city_name, value: item.city_id }));
        setCity(arr);
      });
  };

  const getGender = () => {
    const collectData = { genderID: -1 };
    axios.post(HOST_URL.HOST_URL + `Gender/GetGenderMaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({ label: item.genderName, value: item.genderID }));
        setGender(arr);
      });
  };

  const getRole = () => {
    const collectData = { roleId: "-1" };
    axios.post(HOST_URL.HOST_URL + `RoleMaster/GetRoleMaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({ label: item.roleName, value: item.roleId }));
        setRole(arr);
      });
  };

  const [panOpens, setPanOpen] = React.useState(false);
  const [modalImg, setModalImg] = useState("");
  const [Opens, setOpen] = React.useState(false);
  const [Img, setImg] = useState("");

  const handlePanClose = () => setPanOpen(false);
  const modalOpenHandle = (event: any) => {
    setPanOpen(true);
    if (event === "imageFile") setModalImg(formik.values.imageFile);
  };

  const handlePanClose1 = () => setOpen(false);
  const modalOpenHandle1 = (event: any) => {
    setOpen(true);
    if (event === "signatureFile") setImg(formik.values.signatureFile);
  };

  const ConvertBase64 = (file: Blob) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.onerror = (error) => reject(error);
    });
  };

  const otherDocChangeHandler = async (event: any, params: any) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileNameParts = file.name.split(".");
      const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();

      if (!["jpg", "jpeg"].includes(fileExtension)) {
        alert("Only image files (jpg, jpeg) are allowed to be uploaded.");
        event.target.value = null;
        return;
      }

      if (fileNameParts.length > 2) {
        alert("Files with multiple extensions are not allowed for security reasons.");
        event.target.value = null;
        return;
      }

      if (!file.type.startsWith("image/") || !["image/jpeg"].includes(file.type)) {
        alert("Invalid file type. Only JPEG images are allowed.");
        event.target.value = null;
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = async () => {
          const base64 = await ConvertBase64(file);
          formik.setFieldValue(params, base64);
        };
        img.onerror = () => {
          alert("File content is not a valid image.");
          event.target.value = null;
        };
        img.src = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  };

  let navigate = useNavigate();
  const [toaster, setToaster] = useState(false);

  const validationSchema = Yup.object({
    empName: Yup.string().test("required", t("text.reqEmpName"), (value: any) => value && value.trim() !== ""),
    empCode: Yup.string().test("required", t("text.reqEmpCode"), (value: any) => value && value.trim() !== ""),
    empFatherName: Yup.string().test("required", t("text.reqFatherName"), (value: any) => value && value.trim() !== ""),
    empMobileNo: Yup.string().test("required", t("text.reqMobNo"), (value: any) => value && value.trim() !== ""),

    empPanNumber: Yup.string()
      .required(t("text.reqPanNo"))
      .test("pan-validation", "Invalid PAN format", function (value) {
        if (!value) return false;
        if (value.includes("X")) return true;
        return /^[A-Z]{3}[A-ZHPTCF][A-Z]\d{4}[A-Z]$/.test(value);
      }),

    empDob: Yup.string().test("required", t("text.reqEmpdob"), (value: any) => value && value.trim() !== ""),
    empJoiningDate: Yup.string().test("required", t("text.reqJoiningDate"), (value: any) => value && value.trim() !== ""),
    empretirementDate: Yup.string().test("required", "Retirement Date is required", (value: any) => value && value.trim() !== ""),
    
    empDesignationId: Yup.string().test("required", t("text.reqDesignation"), (value: any) => value && value.trim() !== "" && value !== "-1"),
    empDeptId: Yup.string().test("required", t("text.reqDepartment"), (value: any) => value && value.trim() !== "" && value !== "-1"),
    empCountryID: Yup.string().test("required", "Country is required", (value: any) => value && value.trim() !== "" && value !== "-1"),
    empStateId: Yup.string().test("required", "State is required", (value: any) => value && value.trim() !== "" && value !== "-1"),
    empCityId: Yup.string().test("required", "District is required", (value: any) => value && value.trim() !== "" && value !== "-1"),

    empPerAddress: Yup.string().test("required", t("text.reqPerAddress"), (value: any) => value && value.trim() !== ""),
    empPincode: Yup.string().test("required", t("text.reqPinCode"), (value: any) => value && value.trim() !== ""),

    empAddharNo: Yup.string()
  .required(t("text.reqAdharNo"))
  .test("len", function (val) {
    if (!val) return false;
    if (val.includes("X")) return true;
    return true;
  }),

    email: Yup.string()
      .required(t("text.reqEmail"))
      .test("is-valid-email", t("text.reqEmail"), function (value: any) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
      }),
  });


// Backend encryption key se match karni chahiye
  const SECRET_KEY = "Msspl@2024-CSA-Secret-Key-32Byte";

  const formik = useFormik({
    initialValues: {
      empid: -1,
      empName: "",
      empCode: "",
      empPerAddress: "",
      empFatherName: "",
      empspauseName: "",
      empMotherName: "",
      empMobileNo: "",
      empStatus: "",
      empPanNumber: "",
      empAddharNo: "",
      empDob: "",
      empJoiningDate: "",
      empretirementDate: "",
      empPincode: "",
      roleId: "-1",
      imageFile: "",
      signatureFile: "",
      email: "",
      dlno: "",
      gender: "",
      empLocalAddress: "",
      empDesignationId: "",
      empDeptId: "",
      empStateId: "",
      empCountryID: "",
      empCityId: "",
      user_ID: "-1",
    },
    validationSchema: validationSchema,
   onSubmit: async (values) => {
      try {
        // ✅ फ्रंटएंड पर CryptoJS से एन्क्रिप्ट करके भेजें ताकि ऑडिटर की डिमांड पूरी रहे
        const encryptedPan = values.empPanNumber && !values.empPanNumber.includes("X")
          ? CryptoJS.AES.encrypt(values.empPanNumber, SECRET_KEY).toString() 
          : values.empPanNumber;
        
        const encryptedAadhaar = values.empAddharNo && !values.empAddharNo.includes("X")
          ? CryptoJS.AES.encrypt(values.empAddharNo, SECRET_KEY).toString() 
          : values.empAddharNo;

        const payload = {
          ...values,
          empPanNumber: encryptedPan,
          empAddharNo: encryptedAadhaar,
        };

        const response = await axios.post(HOST_URL.HOST_URL2 + `EmpMaster/AddUpdateEmpmaster`, payload);
        
        if (response.data && response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg || "Employee saved successfully");
          navigate("/Employee/EmployeeMaster");
        } else {
          setToaster(true);
          toast.error(response.data?.mesg || "Failed to save employee data.");
        }
      } catch (error: any) {
        setToaster(true);
        const errorMsg = error.response?.data?.mesg || "An error occurred. Please try again.";
        toast.error(errorMsg);
      }
    },
  });

  const requiredFields = [
    "empName", "empCode", "empPerAddress", "empFatherName", "empMobileNo",
    "empPanNumber", "empDob", "empJoiningDate", "empretirementDate",
    "empDesignationId", "empDeptId", "empCountryID", "empStateId",
    "empCityId", "empAddharNo", "email", "empPincode"
  ];

  const back = useNavigate();

  return (
    <div>
      <div style={{ padding: "-5px 5px", backgroundColor: "#ffffff", borderRadius: "5px", border: ".5px solid #FF7722", marginTop: "3vh" }}>
        <CardContent>
          <Typography variant="h5" textAlign="center" style={{ fontSize: "18px", fontWeight: 500 }}>
            {t("text.CreateEmployeeReg")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button type="submit" onClick={() => back(-1)} variant="contained" style={{ marginBottom: 15, marginTop: "45px", backgroundColor: `var(--header-background)`, width: 20 }}>
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              
              {/* Employee Name */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empName"
                  name="empName"
                  label={
                    <span>
                     {t("text.EnterEmpName")} {" "}
                      {requiredFields.includes("empName") && (
                        <span style={{ color: formik.values.empName ? "green" : "red" }}>*</span>
                      )} 
                    </span>
                  }
                  value={formik.values.empName}
                  placeholder={t("text.EnterEmpName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white", borderColor: formik.touched.empName && formik.errors.empName ? "red" : "initial" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empName && formik.errors.empName ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empName}</div>
                ) : null}
              </Grid>

              {/* Employee Code */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empCode"
                  name="empCode"
                  label={
                    <span>
                      {t("text.EnterEmpCode")} {" "}
                      {requiredFields.includes("empCode") && (
                        <span style={{ color: formik.values.empCode ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empCode}
                  placeholder={t("text.EnterEmpCode")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white", borderColor: formik.touched.empCode && formik.errors.empCode ? "red" : "initial" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empCode && formik.errors.empCode ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empCode}</div>
                ) : null}
              </Grid>

              {/* Father Name */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empFatherName"
                  name="empFatherName"
                  label={
                    <span>
                      {t("text.EnterFatherName")} {" "}
                      {requiredFields.includes("empFatherName") && (
                        <span style={{ color: formik.values.empFatherName ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empFatherName}
                  placeholder={t("text.EnterFatherName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  inputProps={{ pattern: "[A-Za-z\\s'-]*" }}
                />
                {formik.touched.empFatherName && formik.errors.empFatherName ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empFatherName}</div>
                ) : null}
              </Grid>

              {/* Spouse Name */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empspauseName"
                  name="empspauseName"
                  label={t("text.EnterSpauseName")}
                  value={formik.values.empspauseName}
                  placeholder={t("text.EnterSpauseName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              {/* Mother Name */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empMotherName"
                  name="empMotherName"
                  label={t("text.EnterMotherName")}
                  value={formik.values.empMotherName}
                  placeholder={t("text.EnterMotherName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              {/* Mobile No */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empMobileNo"
                  name="empMobileNo"
                  inputProps={{ maxLength: 10 }}
                  label={
                    <span>
                      {t("text.EnterMobileNumber")} {" "}
                      {requiredFields.includes("empMobileNo") && (
                        <span style={{ color: formik.values.empMobileNo ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empMobileNo}
                  placeholder={t("text.EnterMobileNumber")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white", borderColor: formik.touched.empMobileNo && formik.errors.empMobileNo ? "red" : "initial" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empMobileNo && formik.errors.empMobileNo ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empMobileNo}</div>
                ) : null}
              </Grid>

              {/* Email */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="email"
                  name="email"
                  label={
                    <span>
                      {t("text.EnterEmail")} {" "}
                      {requiredFields.includes("email") && (
                        <span style={{ color: formik.values.email ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.email}
                  placeholder={t("text.EnterEmail")}
                  size="small"
                  type="email"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.email}</div>
                ) : null}
              </Grid>

              {/* PAN Number (Secured with Password Type & Eye Icon) */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empPanNumber"
                  name="empPanNumber"
                  type={showPan ? "text" : "password"}
                  label={
                    <span>
                      {t("text.EnterPanNo")} {" "}
                      {requiredFields.includes("empPanNumber") && (
                        <span style={{ color: formik.values.empPanNumber ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empPanNumber}
                  placeholder={t("text.EnterPanNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white", borderColor: formik.touched.empPanNumber && formik.errors.empPanNumber ? "red" : "initial" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPan(!showPan)}
                          edge="end"
                        >
                          {showPan ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.empPanNumber && formik.errors.empPanNumber ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empPanNumber}</div>
                ) : null}
              </Grid>

              {/* Aadhaar Number (Secured with Password Type & Eye Icon) */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empAddharNo"
                  name="empAddharNo"
                  type={showAadhaar ? "text" : "password"}
                  label={
                    <span>
                      {t("text.EnterAdharNo")} {" "}
                      {requiredFields.includes("empAddharNo") && (
                        <span style={{ color: formik.values.empAddharNo ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empAddharNo}
                  placeholder={t("text.EnterAdharNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  inputProps={{ maxLength: 12 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowAadhaar(!showAadhaar)}
                          edge="end"
                        >
                          {showAadhaar ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.empAddharNo && formik.errors.empAddharNo ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empAddharNo}</div>
                ) : null}
              </Grid>

              {/* Date of Birth */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empDob"
                  type="date"
                  name="empDob"
                  label={
                    <span>
                       {t("text.EnterDOB")} {" "}
                      {requiredFields.includes("empDob") && (
                        <span style={{ color: formik.values.empDob ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empDob}
                  placeholder={t("text.EnterDOB")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white", borderColor: formik.touched.empDob && formik.errors.empDob ? "red" : "initial" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                />
                {formik.touched.empDob && formik.errors.empDob ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empDob}</div>
                ) : null}
              </Grid>

              {/* Joining Date (Auto-updates Retirement Date by +1 Year) */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empJoiningDate"
                  name="empJoiningDate"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  label={
                    <span>
                      {t("text.EnterJoiningDate")} {" "}
                      {requiredFields.includes("empJoiningDate") && (
                        <span style={{ color: formik.values.empJoiningDate ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empJoiningDate}
                  placeholder={t("text.EnterJoiningDate")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white", borderColor: formik.touched.empJoiningDate && formik.errors.empJoiningDate ? "red" : "initial" }}
                  onChange={(e) => {
                    formik.handleChange(e);
                    const selectedDate = e.target.value;
                    if (selectedDate) {
                      const dateObj = new Date(selectedDate);
                      dateObj.setFullYear(dateObj.getFullYear() + 1);
                      const nextYearDate = dateObj.toISOString().split("T")[0];
                      formik.setFieldValue("empretirementDate", nextYearDate);
                    }
                  }}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empJoiningDate && formik.errors.empJoiningDate ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empJoiningDate}</div>
                ) : null}
              </Grid>

              {/* Retirement Date (Required & Auto-filled) */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empretirementDate"
                  name="empretirementDate"
                  label={
                    <span>
                      {t("text.EnterRetirementDate")} {" "}
                      {requiredFields.includes("empretirementDate") && (
                        <span style={{ color: formik.values.empretirementDate ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empretirementDate}
                  placeholder={t("text.EnterRetirementDate")}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empretirementDate && formik.errors.empretirementDate ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empretirementDate}</div>
                ) : null}
              </Grid>

              {/* Designation */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  options={EmpDesignation}
                  fullWidth
                  size="small"
                  style={{ backgroundColor: "white" }}
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empDesignationId", newValue?.value || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                         {t("text.SelectDesignation")} {" "}
                          {requiredFields.includes("empDesignationId") && (
                            <span style={{ color: formik.values.empDesignationId && formik.values.empDesignationId !== "-1" ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empDesignationId && formik.errors.empDesignationId ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empDesignationId}</div>
                ) : null}
              </Grid>

              {/* Department */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  options={Department}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empDeptId", newValue?.value || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDepartment")} {" "}
                          {requiredFields.includes("empDeptId") && (
                            <span style={{ color: formik.values.empDeptId && formik.values.empDeptId !== "-1" ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empDeptId && formik.errors.empDeptId ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empDeptId}</div>
                ) : null}
              </Grid>

              {/* Country (Required) */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  options={Country}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empCountryID", newValue?.value || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectCountry")} {""}
                          {requiredFields.includes("empCountryID") && (
                            <span style={{ color: formik.values.empCountryID && formik.values.empCountryID !== "-1" ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empCountryID && formik.errors.empCountryID ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empCountryID}</div>
                ) : null}
              </Grid>

              {/* State (Required) */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  options={StateOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empStateId", newValue?.value || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectState")} {""}
                          {requiredFields.includes("empStateId") && (
                            <span style={{ color: formik.values.empStateId && formik.values.empStateId !== "-1" ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empStateId && formik.errors.empStateId ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empStateId}</div>
                ) : null}
              </Grid>

              {/* District/City (Required) */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  options={City}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empCityId", newValue?.value || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                         {t("text.SelectDistrict")} {""}
                          {requiredFields.includes("empCityId") && (
                            <span style={{ color: formik.values.empCityId && formik.values.empCityId !== "-1" ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empCityId && formik.errors.empCityId ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empCityId}</div>
                ) : null}
              </Grid>

              {/* Role */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  options={Role}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("roleId", newValue?.value ? newValue.value + "" : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                         {t("text.SelectRole")} {""}
                          {requiredFields.includes("roleId") && (
                            <span style={{ color: formik.values.roleId && formik.values.roleId !== "-1" ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.roleId && formik.errors.roleId ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.roleId}</div>
                ) : null}
              </Grid>

              {/* Gender */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  options={Gender}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("gender", newValue?.value ? newValue.value + "" : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                         {t("text.SelectGender")} {""}
                          {requiredFields.includes("gender") && (
                            <span style={{ color: formik.values.gender && formik.values.gender !== "-1" ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.gender && formik.errors.gender ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.gender}</div>
                ) : null}
              </Grid>

              {/* Local Address */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empLocalAddress"
                  name="empLocalAddress"
                  label={t("text.EnterLocalAddress")}
                  value={formik.values.empLocalAddress}
                  placeholder={t("text.EnterLocalAddress")}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              {/* Permanent Address */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empPerAddress"
                  name="empPerAddress"
                  label={
                    <span>
                      {t("text.EnterPerAddress")} {" "}
                      {requiredFields.includes("empPerAddress") && (
                        <span style={{ color: formik.values.empPerAddress ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empPerAddress}
                  placeholder={t("text.EnterPerAddress")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white", borderColor: formik.touched.empPerAddress && formik.errors.empPerAddress ? "red" : "initial" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empPerAddress && formik.errors.empPerAddress ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empPerAddress}</div>
                ) : null}
              </Grid>

              {/* Pin Code */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empPincode"
                  name="empPincode"
                  label={
                    <span>
                      {t("text.EnterPinCode")} {" "}
                      {requiredFields.includes("empPincode") && (
                        <span style={{ color: formik.values.empPincode ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.empPincode}
                  placeholder= {t("text.EnterPinCode")}
                  inputProps={{ maxLength: 6 }}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empPincode && formik.errors.empPincode ? (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.empPincode}</div>
                ) : null}
              </Grid>

              {/* Attached File */}
              <Grid container spacing={1} item>
                <Grid xs={12} md={4} sm={4} item style={{ marginBottom: "30px", marginTop: "30px" }}>
                  <TextField
                    type="file"
                    inputProps={{ accept: ".jpg,.jpeg" }}
                    InputLabelProps={{ shrink: true }}
                    label={<strong style={{ color: "#000" }}>{t("text.AttachedFile")}</strong>}
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e) => otherDocChangeHandler(e, "imageFile")}
                  />
                </Grid>
                <Grid xs={12} md={4} sm={4} item></Grid>
                <Grid xs={12} md={4} sm={4} item>
                  <Grid style={{ display: "flex", justifyContent: "space-around", alignItems: "center", margin: "10px" }}>
                    {formik.values.imageFile === "" ? (
                      <img src={nopdf} style={{ width: 150, height: 100, border: "1px solid grey", borderRadius: 10 }} />
                    ) : (
                      <img src={formik.values.imageFile} style={{ width: 150, height: 100, border: "1px solid grey", borderRadius: 10, padding: "2px" }} />
                    )}
                    <Typography onClick={() => modalOpenHandle("imageFile")} style={{ textDecorationColor: "blue", textDecorationLine: "underline", color: "blue", fontSize: "15px", cursor: "pointer" }}>
                      {t("text.Preview")}
                    </Typography>
                  </Grid>
                </Grid>
                <Modal open={panOpens} onClose={handlePanClose}>
                  <Box sx={style}>
                    {modalImg === "" ? (
                      <img src={nopdf} style={{ width: "170vh", height: "75vh" }} />
                    ) : (
                      <img alt="preview image" src={modalImg} style={{ width: "170vh", height: "75vh", borderRadius: 10 }} />
                    )}
                  </Box>
                </Modal>
              </Grid>

              {/* Signature File */}
              <Grid container spacing={1} item>
                <Grid xs={12} md={4} sm={4} item style={{ marginBottom: "30px", marginTop: "30px" }}>
                  <TextField
                    type="file"
                    inputProps={{ accept: ".jpg,.jpeg" }}
                    InputLabelProps={{ shrink: true }}
                    label={<strong style={{ color: "#000" }}>{t("text.EnterSignatureUpload")}</strong>}
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e) => otherDocChangeHandler(e, "signatureFile")}
                  />
                </Grid>
                <Grid xs={12} md={4} sm={4} item></Grid>
                <Grid xs={12} md={4} sm={4} item>
                  <Grid style={{ display: "flex", justifyContent: "space-around", alignItems: "center", margin: "10px" }}>
                    {formik.values.signatureFile === "" ? (
                      <img src={nopdf} style={{ width: 150, height: 100, border: "1px solid grey", borderRadius: 10 }} />
                    ) : (
                      <img src={formik.values.signatureFile} style={{ width: 150, height: 100, border: "1px solid grey", borderRadius: 10, padding: "2px" }} />
                    )}
                    <Typography onClick={() => modalOpenHandle1("signatureFile")} style={{ textDecorationColor: "blue", textDecorationLine: "underline", color: "blue", fontSize: "15px", cursor: "pointer" }}>
                      {t("text.Preview")}
                    </Typography>
                  </Grid>
                </Grid>
                <Modal open={Opens} onClose={handlePanClose1}>
                  <Box sx={style}>
                    {Img === "" ? (
                      <img src={nopdf} style={{ width: "170vh", height: "75vh" }} />
                    ) : (
                      <img alt="preview image" src={Img} style={{ width: "170vh", height: "75vh", borderRadius: 10 }} />
                    )}
                  </Box>
                </Modal>
              </Grid>

              {/* Buttons */}
              <Grid item lg={6} sm={6} xs={12}>
                <Button type="submit" fullWidth style={{ backgroundColor:`var(--header-background)`, color: "white", marginTop: "10px" }}>
                  {t("text.save")}
                </Button>
              </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button type="reset" fullWidth style={{ backgroundColor: "#F43F5E", color: "white", marginTop: "10px" }} onClick={() => formik.resetForm()}>
                  {t("text.reset")}
                </Button>
              </Grid>

            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default EmployeeAdd;